export const defaultControlAngles = {
  minAzimuthAngle: -Infinity,
  maxAzimuthAngle: Infinity,
  minPolarAngle: null,
  maxPolarAngle: Math.PI / 1.95,
};
